import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

    @Input() title: string;
    @Input() items: any[];
    @Input() active_item: string;
    @Input() Menu: any[];

    constructor(private route: ActivatedRoute, private _router: Router, public common: CommonService) {
        
    }

    ngOnInit() {
        
    }

    changeSubmenu(item: any) {
        this._router.navigate([item.navigateURL]);
    }

}
